
namespace TabAurous.Administration {

    @Serenity.Decorators.registerClass()
    export class FreightGrid extends Serenity.EntityGrid<FreightRow, any> {
        protected getColumnsKey() { return 'Administration.Freight'; }
        protected getDialogType() { return FreightDialog; }
        protected getIdProperty() { return FreightRow.idProperty; }
        protected getInsertPermission() { return FreightRow.insertPermission; }
        protected getLocalTextPrefix() { return FreightRow.localTextPrefix; }
        protected getService() { return FreightService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}